export function thousandsMaskFromValue(value: string): string {
  const digits = value.replace(/\D/g, '');

  if (digits.length === 0) {
    return '#';
  }

  return Number(digits)
    .toString()
    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ')
    .replace(/\d/g, '#');
}

export function makeMaskForSeparatedThousands(value: string): string {
  return thousandsMaskFromValue(value);
}
